// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

const regulatorySettings = {
  bands: [],
  domains: [],
  licenseBases: [],
  radioServices: [],
  rcnStatuses: [],
  pathStatuses: [],
  segmentStatuses: [],
  states: [],
  stationClasses: [],
}

const antennaModes = [{
  mode: 'TX/RX',
  modeId: 'Tx/Rx',
}, {
  mode: 'TX Only',
  modeId: 'Tx only',
}, {
  mode: 'RX Only',
  modeId: 'Rx only',
}]

const passiveRepeaterTypes = [{
  type: 'Billboard',
  typeId: 'billboard',
}, {
  type: 'Back to Back',
  typeId: 'back-to-back',
}]

const radioSettings = {
  architectures: [],
  atpcTypes: [],
  companies: [],
  curveTypeCodes: [],
  duplexModes: [],
  modulationSchemes: [],
  modulationTypes: [],
  powerTypes: [],
  radioTypes: [],
  statuses: [],
}

const frequencySettings = {
  polarizations: [],
}

export const initialState = fromJS({
  // TODO - place all antenna settings inside of antennaSettings
  antennaApplications: [],
  antennaClassifications: [],
  antennaCompanies: [],
  antennaCompliances: [],
  antennaStatuses: [],
  antennaPatternPolarizations: [],
  antennaPolarizations: [],
  antennaModes, // these two are not populated by api but relate to antenna settings.
  passiveRepeaterTypes, // include them inside of antennaSettings.

  frequencySettings,
  regulatorySettings,
  radioSettings,
})
